import PropTypes from 'prop-types';
import IconButton, { ICON_BUTTON_ICONS, ICON_BUTTON_TYPES } from '../../../buttons/IconButton';
import { GRAPH_COPY } from './graph/graphConstants';

/**
 * 'Show in graph' on an Ultimate shareholder(s) or Subsidiaries row whose card the graph does not
 * draw: the host lifts what hides the card, and the graph then focuses it (which highlights it).
 *
 * @param {Object} props
 * @param {Object} props.entry - the row's entry
 * @param {Function} props.onShow - (entry) => reveal the card
 * @param {string} props.hint - the tooltip: what the click changes
 */
const ShowInGraphButton = ({ entry, onShow, hint }) => (
  <IconButton
    accessible
    wrapClassName="show-in-graph-btn"
    ariaLabel={GRAPH_COPY.SHOW_IN_GRAPH}
    icon={ICON_BUTTON_ICONS.BULLSEYE}
    type={ICON_BUTTON_TYPES.BLUE}
    tooltipText={hint}
    onClick={() => onShow(entry)}
  />
);

ShowInGraphButton.propTypes = {
  entry: PropTypes.object.isRequired,
  onShow: PropTypes.func.isRequired,
  hint: PropTypes.string.isRequired
};

export default ShowInGraphButton;
